import React from "react";
import Reveal from "../Reveal";

const GROUPS = [
  {
    title: "Languages",
    items: ["Python", "TypeScript", "JavaScript", "SQL", "HTML", "CSS"],
  },
  {
    title: "Frameworks & Libraries",
    items: [
      "React",
      "Next.js",
      "Redux",
      "Zustand",
      "Node.js",
      "Express.js",
      "Flask",
      "FastAPI",
      "Tailwind CSS",
      "Prisma",
    ],
  },
  {
    title: "DevOps & Cloud",
    items: [
      "AWS Lambda",
      "AWS EC2",
      "AWS Elastic Beanstalk",
      "AWS S3",
      "AWS CodePipeline",
      "AWS CodeBuild",
      "AWS CloudWatch",
      "Docker",
      "Vercel",
      "CI/CD",
    ],
  },
  {
    title: "Databases",
    items: ["PostgreSQL", "MySQL", "AWS RDS"],
  },
  {
    title: "Tools & Platforms",
    items: ["Git", "GitHub", "Postman", "Figma", "Playwright", "Mintlify"],
  },
];

export default function Skills() {
  return (
    <section id="skills" className="relative py-28 px-6 bg-white/[0.015]">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <span className="text-accent-light text-sm font-semibold tracking-widest uppercase">
            Skills
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mt-2 mb-12">
            Technologies I work with
          </h2>
        </Reveal>

        <div className="rounded-2xl border border-white/5 bg-white/[0.03] divide-y divide-white/5 overflow-hidden">
          {GROUPS.map((group, i) => (
            <Reveal key={group.title} delay={i * 80}>
              <div className="grid sm:grid-cols-[200px_1fr] gap-3 sm:gap-8 p-6 transition-colors hover:bg-white/[0.02]">
                <h3 className="text-white font-semibold shrink-0">{group.title}</h3>
                <div className="flex flex-wrap gap-2">
                  {group.items.map((item) => (
                    <span
                      key={item}
                      className="px-3 py-1.5 rounded-lg bg-white/5 border border-white/10 text-zinc-300 text-sm"
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
